var map = {
	"./acaademForm.json": 93309,
	"./academ.json": 54360,
	"./accounting.json": 78867,
	"./admin.json": 18455,
	"./adminPage.json": 5152,
	"./archive.json": 23518,
	"./assignments.json": 10706,
	"./auth.json": 43068,
	"./auto.json": 47147,
	"./calendar.json": 90105,
	"./career.json": 71161,
	"./chat.json": 84650,
	"./chatForm.json": 98164,
	"./collective.json": 95418,
	"./common.json": 85331,
	"./components.json": 64903,
	"./dashboard.json": 75341,
	"./deanDash.json": 83509,
	"./diploma.json": 85643,
	"./distance.json": 10596,
	"./dorm.json": 76066,
	"./dpo.json": 62214,
	"./employees.json": 60116,
	"./europass.json": 8927,
	"./foreign.json": 54144,
	"./forms.json": 58448,
	"./gradebook.json": 7293,
	"./groups.json": 91118,
	"./help.json": 46662,
	"./helpPage.json": 21928,
	"./helpers.json": 58451,
	"./hooks.json": 1339,
	"./integrations.json": 36527,
	"./journal.json": 23527,
	"./kanban.json": 91338,
	"./lang.json": 65154,
	"./library.json": 38052,
	"./loginPage.json": 16582,
	"./main.json": 45090,
	"./menu.json": 67114,
	"./menuDrawer.json": 75919,
	"./military.json": 4661,
	"./noMatch.json": 89439,
	"./notes.json": 88945,
	"./notification.json": 93750,
	"./orderForm.json": 90161,
	"./orders.json": 35388,
	"./ordersPage.json": 23405,
	"./pages.json": 76037,
	"./plagiarism.json": 70156,
	"./postgrad.json": 22443,
	"./practice.json": 75578,
	"./profile.json": 78054,
	"./profilePage.json": 37356,
	"./qr.json": 80003,
	"./quiz.json": 5629,
	"./quizForm.json": 48503,
	"./report_card.json": 38901,
	"./reports.json": 56864,
	"./schedule.json": 68925,
	"./science.json": 52538,
	"./sessions.json": 22890,
	"./statements.json": 58490,
	"./statementsPage.json": 22128,
	"./statistic.json": 6017,
	"./statisticPage.json": 26335,
	"./structure.json": 2543,
	"./structureForm.json": 38362,
	"./studentDash.json": 62363,
	"./studentLife.json": 448,
	"./students.json": 91647,
	"./subjectPage.json": 78632,
	"./support.json": 76560,
	"./survey.json": 34343,
	"./surveyForm.json": 70358,
	"./surveys.json": 56510,
	"./syllabus.json": 63812,
	"./taskForm.json": 71438,
	"./taskInfo.json": 30686,
	"./taskItem.json": 79672,
	"./tasks.json": 96355,
	"./tasksPage.json": 87180,
	"./teacherDash.json": 64402,
	"./test.json": 9602,
	"./testForm.json": 38368,
	"./tests.json": 33001,
	"./ui.json": 35233,
	"./user.json": 45719,
	"./utils.json": 63008,
	"./weather.json": 1120,
	"locales/ru/acaademForm.json": 93309,
	"locales/ru/academ.json": 54360,
	"locales/ru/accounting.json": 78867,
	"locales/ru/admin.json": 18455,
	"locales/ru/adminPage.json": 5152,
	"locales/ru/archive.json": 23518,
	"locales/ru/assignments.json": 10706,
	"locales/ru/auth.json": 43068,
	"locales/ru/auto.json": 47147,
	"locales/ru/calendar.json": 90105,
	"locales/ru/career.json": 71161,
	"locales/ru/chat.json": 84650,
	"locales/ru/chatForm.json": 98164,
	"locales/ru/collective.json": 95418,
	"locales/ru/common.json": 85331,
	"locales/ru/components.json": 64903,
	"locales/ru/dashboard.json": 75341,
	"locales/ru/deanDash.json": 83509,
	"locales/ru/diploma.json": 85643,
	"locales/ru/distance.json": 10596,
	"locales/ru/dorm.json": 76066,
	"locales/ru/dpo.json": 62214,
	"locales/ru/employees.json": 60116,
	"locales/ru/europass.json": 8927,
	"locales/ru/foreign.json": 54144,
	"locales/ru/forms.json": 58448,
	"locales/ru/gradebook.json": 7293,
	"locales/ru/groups.json": 91118,
	"locales/ru/help.json": 46662,
	"locales/ru/helpPage.json": 21928,
	"locales/ru/helpers.json": 58451,
	"locales/ru/hooks.json": 1339,
	"locales/ru/integrations.json": 36527,
	"locales/ru/journal.json": 23527,
	"locales/ru/kanban.json": 91338,
	"locales/ru/lang.json": 65154,
	"locales/ru/library.json": 38052,
	"locales/ru/loginPage.json": 16582,
	"locales/ru/main.json": 45090,
	"locales/ru/menu.json": 67114,
	"locales/ru/menuDrawer.json": 75919,
	"locales/ru/military.json": 4661,
	"locales/ru/noMatch.json": 89439,
	"locales/ru/notes.json": 88945,
	"locales/ru/notification.json": 93750,
	"locales/ru/orderForm.json": 90161,
	"locales/ru/orders.json": 35388,
	"locales/ru/ordersPage.json": 23405,
	"locales/ru/pages.json": 76037,
	"locales/ru/plagiarism.json": 70156,
	"locales/ru/postgrad.json": 22443,
	"locales/ru/practice.json": 75578,
	"locales/ru/profile.json": 78054,
	"locales/ru/profilePage.json": 37356,
	"locales/ru/qr.json": 80003,
	"locales/ru/quiz.json": 5629,
	"locales/ru/quizForm.json": 48503,
	"locales/ru/report_card.json": 38901,
	"locales/ru/reports.json": 56864,
	"locales/ru/schedule.json": 68925,
	"locales/ru/science.json": 52538,
	"locales/ru/sessions.json": 22890,
	"locales/ru/statements.json": 58490,
	"locales/ru/statementsPage.json": 22128,
	"locales/ru/statistic.json": 6017,
	"locales/ru/statisticPage.json": 26335,
	"locales/ru/structure.json": 2543,
	"locales/ru/structureForm.json": 38362,
	"locales/ru/studentDash.json": 62363,
	"locales/ru/studentLife.json": 448,
	"locales/ru/students.json": 91647,
	"locales/ru/subjectPage.json": 78632,
	"locales/ru/support.json": 76560,
	"locales/ru/survey.json": 34343,
	"locales/ru/surveyForm.json": 70358,
	"locales/ru/surveys.json": 56510,
	"locales/ru/syllabus.json": 63812,
	"locales/ru/taskForm.json": 71438,
	"locales/ru/taskInfo.json": 30686,
	"locales/ru/taskItem.json": 79672,
	"locales/ru/tasks.json": 96355,
	"locales/ru/tasksPage.json": 87180,
	"locales/ru/teacherDash.json": 64402,
	"locales/ru/test.json": 9602,
	"locales/ru/testForm.json": 38368,
	"locales/ru/tests.json": 33001,
	"locales/ru/ui.json": 35233,
	"locales/ru/user.json": 45719,
	"locales/ru/utils.json": 63008,
	"locales/ru/weather.json": 1120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94481;